import {Form} from 'antd';
import moment from 'moment';
import React, {useEffect, useState} from 'react';

import {detectAutoDetect} from '../../../../constants/Common';
import {APITypeEnum} from '../../../../services/interface/tableAPIType';
import fugitiveAPI from '../../../../services/modules/IP/fugitiveAPI';
import emissionSourceJSON from '../../../../services/modules/JSON/emissionSource';
import frequencyJSON from '../../../../services/modules/JSON/frequency';
import refrigerantTypeJSON from '../../../../services/modules/JSON/refrigentType';
import refrigerantUsed from '../../../../services/modules/JSON/refriUsed';
import RefriForm from '../../../Forms/RefriForm';
import Loader from '../../../Loader/Loader';
import {IComponentProps} from '../../Common/perquisiteMaster';

const RefrigerantBills: React.FC<IComponentProps> = ({
  record,
  caForm,
  onFinishFailed,
  onValuesChange,
  onSubmit
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const initialValues = {
    facility: record?.facility,
    year: record?.year
  };

  useEffect(() => {
    Promise.all([
      record?.referenceRecordId &&
        fugitiveAPI(APITypeEnum.GET_ONE, {}, record?.referenceRecordId),
      emissionSourceJSON(),
      frequencyJSON(),
      refrigerantUsed(),
      refrigerantTypeJSON()
    ])
      .then(([res1]) => {
        if (res1?.data?.isDeleted === false) {
          caForm.setFieldsValue({
            ...res1?.data,
            dateOfInstallation: res1?.data?.dateOfInstallation
              ? moment(res1?.data?.dateOfInstallation)
              : null
          });
          onValuesChange(true);
        }
      })
      .catch(() => {
        setIsLoading(false);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <Form
      form={caForm}
      onFinish={onSubmit}
      onFinishFailed={() => {
        onFinishFailed();
      }}
      onValuesChange={() => {
        onValuesChange(false);
      }}
      initialValues={initialValues}
      autoComplete={detectAutoDetect()}
      layout="vertical"
      className="drawerForm"
    >
      <RefriForm defaultDisplayStep={true} />
    </Form>
  );
};

export default RefrigerantBills;
